import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import { EntStorageRegister } from "../../../../models/organic/storage";
import { EntStorageFilter } from "../../../../models/filters/organic/storageFilter";
import { useLazyGetStorageListQuery } from "../../../../redux/api/organic/storageApi";
import { EmptyData } from "../../../../components/empty/emptyData";
import { PageHeader } from "../../../../components/page-header";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { FilterStorage } from "./FilterStorage";
import { AddStorageModal } from "./AddStorage";
import { useStorage } from "./useStorage";
import _ from "lodash";

enum FormField {
  storageName,
  regionId,
  areaId,
  territorialUnitId,
  productType
}

export const Storage = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntStorageRegister>(new EntStorageRegister());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [form] = useForm();
  const { t } = useTranslation()

  const [getArchiveFolders] = useLazyGetStorageListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntStorageRegister, EntStorageFilter>({
	initialFilter: new EntStorageFilter(),
	query: getArchiveFolders
  });

  const {
	onAddStorage, onDeleteStorage, onEditStorage
  } = useStorage(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isReportAvailable = storedData.some((route: any) => (route.alias === "/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntStorageRegister) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntStorageFilter => {
	let filt: EntStorageFilter = _.clone(filter);

	filt.storageName = form.getFieldValue(FormField.storageName) ?? null;
	filt.regionId = form.getFieldValue(FormField.regionId) ?? null;
	filt.areaId = form.getFieldValue(FormField.areaId ?? null);
	filt.territorialUnitId = form.getFieldValue(FormField.territorialUnitId) ?? null;
	filt.productType = form.getFieldValue(FormField.productType) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.storageName, value: null },
	  { name: FormField.regionId, value: null },
	  { name: FormField.areaId, value: null },
	  { name: FormField.territorialUnitId, value: null },
	  { name: FormField.productType, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('Название хранилища') }</th>
		  <th>{ t('Юридическое лицо') }</th>
		  <th>{ t('Регион') }</th>
		  <th>{ t('Район') }</th>
		  <th>{ t('Территориальная единица') }</th>
		  <th>{ t('Год отчетности') }</th>
		  <th>{ t('Емкость (тонн)') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ? (
		  <tr>
			<th colSpan={ 9 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		) : null }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item.storageName }</td>
			<td>{ item.legalEntity }</td>
			<td>{ i18n.language === 'ru' ? item.region?.nameRu : item.region?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.area?.nameRu : item.area?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.territorialUnit?.nameRu : item.territorialUnit?.nameKy }</td>
			<td>{ item.yearReported }</td>
			<td>{ item.capacity?.capacityTonnes?.toLocaleString() }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteStorage(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : (
		  <tr>
			<td colSpan={ 9 }>
			  <EmptyData/>
			</td>
		  </tr>
		) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('Хранилища') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntStorageRegister())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterStorage
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } }
		  formField={ FormField }
		  form={ form }
		/> }
		setHeight={ setHeight }
		table={ table }
	  />

	  <AddStorageModal
		item={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditStorage : onAddStorage }
	  />
	  { contextHolder }
	</>
  );
}
